import { FilterCompanyAnnualReviewWebPage, getCompanyAnnualReviewWebPage } from 'commons/service/bank/companyDetails'
import { CompanyAnnualReviewWebPage } from 'commons/types/DTO/bank/companyDetails/annualReview'
import { WriteHook, useMutationManager } from 'state-manager'

export const useFilterCompanyAnnualReviewWebPage: WriteHook<
  FilterCompanyAnnualReviewWebPage,
  CompanyAnnualReviewWebPage
> = (opts) => useMutationManager(getCompanyAnnualReviewWebPage, opts)
